import Link from 'next/link';

export default function InternalLinkMobile({
  id,
	linkInternal,
	children,
}) {
	return (
    <Link
      href={linkInternal?.kind === 0 ? "/[event]" : "/[event]/[page]"}
      as={linkInternal?.getFrontendUrl}
    >
      <a id={`action-point-${id}`}>{children}</a>
    </Link>
  );
}
